import { IGenerateNFFResponse } from "@/@types/nff";
import { Tags } from "@/enum/tags";
import { apiSlice } from "./http";

export const nffService = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    generateNFF: builder.mutation<
      IGenerateNFFResponse,
      { params: Record<string, string> }
    >({
      query: ({ params }) => {
        const urlParams = new URLSearchParams(params);
        return {
          url: `/invoice/nff-create?${urlParams.toString()}`,
          method: "POST",
        };
      },
      invalidatesTags: [Tags.TAX_INTEGRATION],
    }),

    sendNFFExcel: builder.mutation<IGenerateNFFResponse, FormData>({
      query: (formData) => ({
        url: `/invoice/nff-send-excel`,
        method: "POST",
        body: formData,
      }),
      invalidatesTags: [Tags.TAX_INTEGRATION],
    }),

    downloadNFFModel: builder.mutation<{ excelFile: string }, void>({
      query: () => ({
        url: `/invoice/nff-excel-model`,
        method: "POST",
      }),
    }),
  }),
  overrideExisting: true,
});

export const {
  useGenerateNFFMutation,
  useSendNFFExcelMutation,
  useDownloadNFFModelMutation,
} = nffService;

